import { forwardRef } from "react";
import {
  TextField as MuiTextField,
  TextFieldProps as MuiTextFieldProps,
} from "@mui/material";

export type TextFieldProps = {
  fieldError?: { message?: string };
  hideHelperTextSpace?: boolean;
} & MuiTextFieldProps;

export const TextField = forwardRef<HTMLInputElement, TextFieldProps>(
  (
    {
      name,
      fieldError,
      fullWidth = true,
      hideHelperTextSpace,
      ...textFieldProps
    },
    ref
  ) => {
    const error = {
      error: !!fieldError?.message,
      helperText: fieldError?.message
        ? fieldError.message
        : hideHelperTextSpace
        ? ""
        : " ",
    };

    const inputProps = {
      ...textFieldProps.inputProps,
      maxLength: textFieldProps.inputProps?.maxLength || 100,
    };

    const InputLabelProps = {
      shrink: true,
      ...textFieldProps.InputLabelProps,
    };

    const id = textFieldProps.id ?? name;

    return (
      <MuiTextField
        type="text"
        fullWidth={fullWidth}
        name={name}
        id={id}
        ref={ref}
        {...textFieldProps}
        {...error}
        inputProps={inputProps}
        InputLabelProps={InputLabelProps}
      />
    );
  }
);

TextField.displayName = "TextField";
